import useSWRImmutable from 'swr/immutable';

import type { UserAccountDto } from '@dto/UserAccount.dto';
import { getAPIFetcher } from '@isomorphic/swr-fetchers';

export const useAccountStore = (): {
  isLoading: boolean;
  isError?: string;
  account?: UserAccountDto;
} => {
  const { data, error } = useSWRImmutable<UserAccountDto>('/docs/api/user-account', getAPIFetcher, {
    errorRetryCount: 1,
  });

  return {
    account: data,
    isLoading: !data && !error,
    isError: error,
  };
};
